import { render, staticRenderFns } from "./WDiscountsDetail.vue?vue&type=template&id=71de8192&scoped=true&"
import script from "./WDiscountsDetail.vue?vue&type=script&lang=js&"
export * from "./WDiscountsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de8192",
  null
  
)

export default component.exports